// extracted by mini-css-extract-plugin
module.exports = {"anticon":"app-anticon-2Jrts"};